<li class="page-item" [class.disabled]="isDisabled">
    <a class="page-link" [class.active]="! isDisabled" matTooltip="{{ 'refresh' | translate }}"><fa-icon [icon]="['fas', 'sync-alt']"></fa-icon></a>
  </li>